var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Field", {
        attrs: {
          label: _vm.$t("DIAL_SETTINGS_REVENUE_RECOVERY"),
          "has-tooltip": true,
          "tooltip-text": _vm.tooltipText
        },
        scopedSlots: _vm._u([
          {
            key: "element",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "col-sm-6 toggle-wrap" },
                  [
                    _c("MultipleToggle", {
                      attrs: {
                        value: _vm.override,
                        options: _vm.toggleOptions
                      },
                      on: { onToggle: _vm.onRevenueRecoveryChange }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.override
        ? [
            _c("Field", {
              attrs: {
                label: _vm.$t("DIAL_SETTINGS_REVENUE_RECOVERY_CONNECTION"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t(
                  "DIAL_SETTINGS_REVENUE_RECOVERY_CONNECTION_TT"
                )
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "element",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "col-sm-9" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentSetting.callLengthReroute,
                                expression: "currentSetting.callLengthReroute"
                              }
                            ],
                            staticClass: "form-control input-sm",
                            attrs: {
                              placeholder: "10",
                              name: "callLengthReroute",
                              type: "number"
                            },
                            domProps: {
                              value: _vm.currentSetting.callLengthReroute
                            },
                            on: {
                              change: _vm.onInputChange,
                              input: [
                                function($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.currentSetting,
                                    "callLengthReroute",
                                    $event.target.value
                                  )
                                },
                                _vm.onInputChange
                              ],
                              wheel: function($event) {
                                return $event.target.blur()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("label", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "SECONDS",
                                expression: "'SECONDS'"
                              }
                            ],
                            staticClass: "control-label m-l-10"
                          })
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                630269102
              )
            }),
            _vm._v(" "),
            _c("Field", {
              attrs: {
                label: _vm.$t("DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS"),
                "has-tooltip": true,
                "tooltip-text": _vm.$t(
                  "DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS_TT"
                )
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "element",
                    fn: function() {
                      return [
                        _c("ValidationProvider", {
                          ref: "maxRerouteAttempts",
                          attrs: { rules: "min_value:0|max_value:5", slim: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ classes, errors }) {
                                  return [
                                    _c("div", { class: classes }, [
                                      _c("div", { staticClass: "col-sm-9" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.currentSetting
                                                  .maxRerouteAttempts,
                                              expression:
                                                "currentSetting.maxRerouteAttempts"
                                            }
                                          ],
                                          staticClass: "form-control input-sm",
                                          attrs: {
                                            placeholder: "2",
                                            name: "maxRerouteAttempts",
                                            type: "number"
                                          },
                                          domProps: {
                                            value:
                                              _vm.currentSetting
                                                .maxRerouteAttempts
                                          },
                                          on: {
                                            change: _vm.onInputChange,
                                            input: [
                                              function($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.currentSetting,
                                                  "maxRerouteAttempts",
                                                  $event.target.value
                                                )
                                              },
                                              _vm.onInputChange
                                            ],
                                            wheel: function($event) {
                                              return $event.target.blur()
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        errors && errors[0]
                                          ? _c("label", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value:
                                                    "DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS_ERROR",
                                                  expression:
                                                    "'DIAL_SETTINGS_REVENUE_RECOVERY_ATTEMPTS_ERROR'"
                                                }
                                              ],
                                              staticClass:
                                                "form-group__label-required m-l-10"
                                            })
                                          : _vm._e()
                                      ])
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2429960544
                          )
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                734756814
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }